var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPremio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1003 21.6664L16.0003 19.2998L19.9003 21.6664L18.8669 17.2331L22.3336 14.2331L17.7669 13.8664L16.0003 9.66644L14.2336 13.8664L9.66693 14.2331L13.1336 17.2331L12.1003 21.6664ZM16.0003 31.0664L11.5336 26.6664H5.33359V20.4664L0.933594 15.9998L5.33359 11.5331V5.33311H11.5336L16.0003 0.933105L20.4669 5.33311H26.6669V11.5331L31.0669 15.9998L26.6669 20.4664V26.6664H20.4669L16.0003 31.0664ZM16.0003 27.3331L19.3336 23.9998H24.0003V19.3331L27.3336 15.9998L24.0003 12.6664V7.99977H19.3336L16.0003 4.66644L12.6669 7.99977H8.00026V12.6664L4.66693 15.9998L8.00026 19.3331V23.9998H12.6669L16.0003 27.3331Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPremio);
export default __webpack_public_path__ + "static/media/ic_premio.54fbd14ba38995fff4de22b523b66cfd.svg";
export { ForwardRef as ReactComponent };